import { HttpMethod, httpClient } from './http-client';
import { PrintLabelEntityTypes } from '../@types/print-label.type';

// Both BFF endpoints return the payload as a raw string (label template or
// signed message), not a wrapper object. A prior typed-refactor assumed
// `{ label }` / `{ signedMessage }` shapes and silently broke printing.
export const getPrintLabel = (
  entityType: PrintLabelEntityTypes,
  entityId: number
): Promise<string> => {
  return httpClient<string>(`/printLabel/${entityId}/entityType/${entityType}`, HttpMethod.Get);
};

export const getSignedMessage = (content: string): Promise<string> => {
  return httpClient<string>('/printLabel/signMessage', HttpMethod.Post, { content });
};
